// extracted by mini-css-extract-plugin
export default {"wrapper":"ID-z","viewport":"JD-z","container":"KD-z","slide":"LD-z"};